// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { ReactNode } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import styled from "styled-components";

const mapStateToProps = (state: CustomAppState) => {
    return {
        breadcrumbActions: state.commonActions["breadcrumbActions"],
    };
};

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

export interface PageLayoutStyles {
    page?: InjectableCss;
}

export const styles: PageLayoutStyles = {
    page: {
        css: css`
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 10px auto;
            @media (max-width: 768px) {
                position: static !important;
            }
        `,
    },
};

type Props = PageLayoutProps & ReturnType<typeof mapStateToProps>;

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
    // Xng-Change
    breadcrumbActions,
}: Props) => {
    return (
        <PageLayoutWrapper>
            {showHeader && header}
            {showBreadcrumbs && (
                <Page as="div" {...styles.page}>
                    <PageBreadcrumbs />
                    {breadcrumbActions}
                </Page>
            )}
            {pageContent}
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    @media print {
        display: block;
    }
`;

export default connect(mapStateToProps)(PageLayout);
